'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _day = require('./day');

var _day2 = _interopRequireDefault(_day);

var _Time = require('@wix/wixrest-utils/dist/Time');

var _Time2 = _interopRequireDefault(_Time);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Week = function (_React$Component) {
    _inherits(Week, _React$Component);

    function Week(props) {
        _classCallCheck(this, Week);

        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

        _this.handleDayClick = function (day) {
            if (_this.props.onDayClick) {
                _this.props.onDayClick(day);
            }
        };

        _this.renderDays = function () {
            var startOfWeek = _this.props.day.clone().startOf('week');
            return [0, 1, 2, 3, 4, 5, 6].map(function (offset) {
                var day = startOfWeek.clone().add(offset, 'days');
                var serializedDay = _Time2.default.serializeDate(day);
                return _react2.default.createElement(_day2.default, { key: offset,
                    ref: function ref(el) {
                        return _this.days[serializedDay] = el;
                    },
                    locale: _this.props.locale,
                    timezone: _this.props.timezone,
                    day: day,
                    month: _this.props.month,
                    onClick: _this.handleDayClick.bind(_this, day),
                    minDate: _this.props.minDate,
                    maxDate: _this.props.maxDate,
                    onlyMonthDays: _this.props.onlyMonthDays,
                    disabled: _this.props.excludeDates[serializedDay],
                    includeDates: _this.props.includeDates,
                    filterDate: _this.props.filterDate,
                    selected: _this.props.selected,
                    startDate: _this.props.startDate,
                    hovered: _this.props.hovered,
                    setHover: _this.props.setHover,
                    endDate: _this.props.endDate });
            });
        };

        _this.days = {};
        _this.state = {};
        return _this;
    }

    Week.prototype.render = function render() {
        return _react2.default.createElement(
            'div',
            { className: 'wix-dropdown-datepicker__week', role: 'row' },
            this.renderDays()
        );
    };

    return Week;
}(_react2.default.Component);

Week.displayName = 'Week';
Week.defaultProps = {
    excludeDates: {}
};


module.exports = Week;